import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import { useRouter } from '@uirouter/react';

import { notifySuccess } from '@/portainer/services/notifications';

import { LoadingButton } from '@@/buttons';

import { Workflow } from '../types';
import { useDetachWorkflowMutation } from '../queries/useDetachWorkflowMutation';
import { useDestroyWorkflowMutation } from '../queries/useDestroyWorkflowMutation';

import { WorkflowDeleteModal, WorkflowDeleteMode } from './WorkflowDeleteModal';

export function WorkflowDeleteButton({ workflow }: { workflow: Workflow }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const detachMutation = useDetachWorkflowMutation();
  const destroyMutation = useDestroyWorkflowMutation();
  const router = useRouter();

  const isLoading = detachMutation.isLoading || destroyMutation.isLoading;

  return (
    <>
      <LoadingButton
        type="button"
        icon={Trash2}
        color="dangerlight"
        isLoading={isLoading}
        loadingText="Deleting..."
        onClick={() => setIsModalOpen(true)}
        data-cy="workflow-delete-button"
      >
        Delete
      </LoadingButton>
      {isModalOpen && (
        <WorkflowDeleteModal
          onCancel={() => setIsModalOpen(false)}
          onConfirm={handleConfirm}
        />
      )}
    </>
  );

  function handleConfirm(mode: WorkflowDeleteMode) {
    setIsModalOpen(false);

    if (mode === 'detach') {
      detachMutation.mutate(workflow.id, {
        onSuccess() {
          notifySuccess('Success', 'Workflow detached');
          router.stateService.go('portainer.gitops.workflows');
        },
      });
      return;
    }

    destroyMutation.mutate(workflow.id, {
      onSuccess() {
        notifySuccess('Success', 'Workflow destroyed');
        router.stateService.go('portainer.gitops.workflows');
      },
    });
  }
}
